import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchOneProduct } from '../http/productAPI';
import { getImageUrl } from '../utils/imageUtils';

const PrintProduct = () => {
    const { id } = useParams();
    const [product, setProduct] = useState(null);

    useEffect(() => {
        fetchOneProduct(id).then(data => setProduct(data));
    }, [id]);

    if (!product) {
        return <div>Загрузка...</div>;
    }

    return (
        <div>
            <img 
                src={getImageUrl(product.img)} 
                alt={product.name} 
                loading="lazy"
                decoding="async"
                style={{ width: '25%', height: 'auto' }}
            />
            <h2>{product.name}</h2>
            <p>Цена: {product.price} руб.</p>
            <p>Количество на складе: {product.count}</p>
            <p>Рейтинг: {product.rating}</p>
            <h4>Характеристики:</h4>
            <ul>
                {(product.info || []).map(info => (
                    <li key={info.id}>{info.title}: {info.description}</li>
                ))}
            </ul>
            <button onClick={() => window.print()}>Печать</button>
        </div>
    );
};

export default PrintProduct; 